export default function getQueryVariables(classroomId: string | undefined, classroomIds: string[]) {
  return {
    variables: {classroomIds: classroomId === undefined ? classroomIds : [classroomId]},
    fetchPolicy: 'network-only'
  } as const;
}
